import { FormsModule } from '@angular/forms';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UploadImageComponent } from './upload-image.component';
import {FileUploadModule} from 'primeng/fileupload';
import {HttpClientModule} from '@angular/common/http';
import {PanelModule} from 'primeng/panel';
import {RadioButtonModule} from 'primeng/radiobutton';

@NgModule({
  imports: [
    CommonModule,
    FileUploadModule,
    HttpClientModule,
    PanelModule,
    RadioButtonModule,
    FormsModule
  ],
  declarations: [UploadImageComponent]
})
export class UploadImageModule { }
